import { MoreVert } from '@mui/icons-material';
import { Avatar, List, MenuItem } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { alpha, styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { OutlinedPushPin } from 'icons';

const OverflowText = {
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden' as const,
  textOverflow: 'ellipsis' as const,
};

const StyledAvatar = styled(Avatar)<{ open?: boolean }>(({ theme, open }) => ({
  backgroundColor: 'transparent',
  border: '2px solid white',
  fontWeight: 700,
  fontSize: '1rem',
  marginLeft: !open ? `-${theme.spacing(1)}` : undefined, // Centers the avatar if drawer is closed
}));

const StyledSecondaryLink = styled(Link)(() => ({
  color: 'white',
}));

const StyledSecondaryAction = styled('span')(() => ({
  color: 'white',
  font: 'inherit',
  cursor: 'pointer',
  textDecoration: 'underline',
}));

const StyledBottomMenuSubMenuIcon = styled(MoreVert)(() => ({
  color: 'white',
}));

const StyledMenuItemsLabel = styled(MenuItem)(() => ({
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '0.75rem',
  lineHeight: '16px',
  textTransform: 'uppercase',
}));

const StyledMenuItem = styled(MenuItem)(() => ({
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1rem',
  lineHeight: '30px',
}));

const StyledMenuItemIcon = styled('div')(() => ({
  paddingRight: '.5em',
}));

const StyledList = styled(List)(() => ({
  marginBottom: '4rem',
}));

const getDropdownInteractiveStateStyles = (theme: Theme) => ({
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  backgroundColor: theme.palette.common.white,
  transition: theme.transitions.create(['background-color'], {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    cursor: 'pointer',
  },
  '&:focus-visible, &.Mui-focusVisible': {
    outline: 'none',
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
  '&:active': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
});

const StyleOutlinedPushPin = styled(OutlinedPushPin)(() => ({
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
  '&:hover': {
    opacity: 1,
  },
}));

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '& .MuiListItem-root': {
    ...getDropdownInteractiveStateStyles(theme),
  },
}));

const StyledAddFirmMenuItem = styled(MenuItem)(({ theme }) => ({
  ...getDropdownInteractiveStateStyles(theme),
  width: '100%',
}));

export {
  OverflowText,
  StyledAvatar,
  StyledSecondaryAction,
  StyledSecondaryLink,
  StyledBottomMenuSubMenuIcon,
  StyledMenuItemsLabel,
  StyledMenuItem,
  StyledMenuItemIcon,
  StyledList,
  StyleOutlinedPushPin,
  StyledAddFirmMenuItem,
  StyledLink,
};
